import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from '@tutero/ui';

import { startTelemetry } from './lib/telemetry';
import { makeRouter } from './shell/router';
import { ShellBoundary } from './shell/Shell';
import './index.css';

/**
 * A read is taken as current for 30 seconds: going back to a page or to the tab inside that
 * window answers from the cache instead of reading every pane again. A write still refreshes
 * what it changes at once (invalidation refetches whatever is on screen, however fresh).
 */
const READS_FRESH_MS = 30_000;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: true,
      staleTime: READS_FRESH_MS,
    },
  },
});
const router = makeRouter();

void startTelemetry();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Outermost: the query client and the router are themselves under the shell's boundary (D12). */}
    <ShellBoundary>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster />
      </QueryClientProvider>
    </ShellBoundary>
  </StrictMode>,
);
